import React from 'react'

type Props = {
    module      : any
    children?   : any

    onClick?    : {(e:any):void}
}

const debug = false
// const debug = "FirstColumn"

export default class FirstColumn extends React.Component<Props> {

    onClick = (e: any) => {
        debug && console.log(debug, 'onClick', e)
        e.stopPropagation()
        if (this.props.onClick) this.props.onClick(e)
    }

    render() {
        const styles = {
            width: this.props.module.skin.paddingLeft
        }

        return (
            <div className="first-column" style={styles} onClick={this.onClick}>
                {this.props.children}
            </div>
        )
    }
}
